import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './components/App';

import './style.scss';

ReactDOM.render(<App debugMode={process.env.REACT_APP_DEBUG_MODE} />, document.querySelector('#root'));
